import { useAuthStore } from '@/stores/authStore'

export function usePermissions() {
  const admin = useAuthStore((s) => s.admin)

  const hasPermission = (perm: string): boolean =>
    !!admin?.permissions?.includes('admin:all') ||
    !!admin?.permissions?.includes(perm)

  const hasAny = (perms: string[]): boolean => perms.some(hasPermission)
  const hasAll = (perms: string[]): boolean => perms.every(hasPermission)

  return { hasPermission, hasAny, hasAll }
}
